// Save scroll position to localStorage with a timestamp
export function saveScrollPosition(key) {
  const scrollData = {
    position: window.scrollY,
    timestamp: Date.now()
  };
  localStorage.setItem(`scroll_${key}`, JSON.stringify(scrollData));
}

// Get scroll position from localStorage
export function getScrollPosition(key) {
  try {
    const scrollData = JSON.parse(localStorage.getItem(`scroll_${key}`));

    // If data exists and is less than 5 minutes old
    if (scrollData && Date.now() - scrollData.timestamp < 300000) {
      return scrollData.position;
    }
  } catch (error) {
    console.error("Error retrieving scroll position:", error);
  }

  return 0;
}

// Clear scroll position from localStorage
export function clearScrollPosition(key) {
  localStorage.removeItem(`scroll_${key}`);
}

// Save clicked event ID for better scroll restoration
export function saveClickedEventId(eventId) {
  const eventData = {
    eventId: eventId,
    timestamp: Date.now()
  };
  localStorage.setItem('clicked_event_id', JSON.stringify(eventData));
}

// Get clicked event ID from localStorage
export function getClickedEventId() {
  try {
    const eventData = JSON.parse(localStorage.getItem('clicked_event_id'));

    // If data exists and is less than 5 minutes old
    if (eventData && Date.now() - eventData.timestamp < 300000) {
      return eventData.eventId;
    }
  } catch (error) {
    console.error("Error retrieving clicked event ID:", error);
  }

  return null;
}

// Clear clicked event ID from localStorage
export function clearClickedEventId() {
  localStorage.removeItem('clicked_event_id');
}